import type { LatitudeLongitude } from '@nora-monorepo/shared';

import { GEO_LINK_CLASS_NAME } from '#nora-chat-ui/directives/linkify/types';

function parseFiniteFloat(attributeValue: string | null): number | undefined {
  if (!attributeValue) {
    return;
  }

  const normalizedValue = attributeValue.replace(',', '.');
  const parsedFloat = Number.parseFloat(normalizedValue);

  if (!Number.isFinite(parsedFloat)) {
    return;
  }

  return parsedFloat;
}

function findAnchorElement(event: MouseEvent): HTMLAnchorElement | undefined {
  if (!(event.target instanceof Element)) {
    return;
  }

  const anchorElement = event.target.closest('a');

  if (!(anchorElement instanceof HTMLAnchorElement)) {
    return;
  }

  return anchorElement;
}

export function handleGeoLinkClick(event: MouseEvent): LatitudeLongitude | undefined {
  const anchorElement = findAnchorElement(event);

  if (!anchorElement || !anchorElement.classList.contains(GEO_LINK_CLASS_NAME)) {
    return;
  }

  event.preventDefault();

  const latitude = parseFiniteFloat(anchorElement.getAttribute('data-latitude'));
  const longitude = parseFiniteFloat(anchorElement.getAttribute('data-longitude'));

  if (latitude === undefined || longitude === undefined) {
    return;
  }

  return {
    latitude,
    longitude,
  };
}
